module.exports = __webpack_public_path__ + "dash_20_app_assets/img/susc.0c18a7c1.png";